const ACTIONS_PREFIX = 'ALP_COMPONENTS';

export { ACTIONS_PREFIX };
